import React from 'react';
import Mention from "../Mention";
import {User} from "../../lib/stores/UserStore";

import {Emoji} from "../Emoji";


export const parseContent = (content: string, users: User[]) => {

    // return [content];
    // const mentionRegex = /<@!?(\d+)>/g;
    const regex = /<(@!?(\d+)|(a:)?\w+:\d+)>/g
    const elements = [];
    let lastIndex = 0;

    // Find all mentions in the message
    let match;
    while ((match = regex.exec(content)) !== null) {
        const mentionStart = match.index;
        const mentionEnd = mentionStart + match[0].length;
        const val = match[1];

        // Add the text before the mention
        if (mentionStart > lastIndex) {
            elements.push(content.slice(lastIndex, mentionStart));
        }

        if (val.startsWith("@")) {
            const mentionId = val.slice(1);
            const user = users.find(user => user.id === mentionId);

            if (user) {
                elements.push(<Mention key={mentionStart} user={user}/>);
            } else {
                elements.push(<Mention key={mentionStart} user={{id: mentionId}}/>);
            }
        } else {
            elements.push(<Emoji key={mentionStart} emojiStr={match[0]}/>)

        }
        // Add the Mention component


        lastIndex = mentionEnd;
    }

    // Add the remaining text after the last mention
    if (lastIndex < content.length) {
        elements.push(content.slice(lastIndex));
    }

    // Split the elements by newlines and wrap each line in a div
    const lines: React.JSX.Element[] = [];

    elements.forEach((element, i) => {
        if (typeof element === 'string') {
            const textLines = element.split('\n');

            textLines.forEach((line, j) => {
                lines.push(<React.Fragment key={`${i}-${j}`}>
                    {line}
                    {j !== textLines.length - 1 && <br/>}
                </React.Fragment>);
            });

        } else {
            lines.push(element);
        }
    });

    return lines;
};
